// extracted by mini-css-extract-plugin
export default {"station":"Station_station__DUkU+","code":"Station_code__4E8C6","name":"Station_name__CAHjo"};